export default __webpack_public_path__ + "static/media/arrow-right.0e2d1505.svg";